module.exports = __webpack_public_path__ + "img/no-list.01b98068.png";